/* globals document, $, window, fetch, config, NProgress */

'use strict';

$(document).ready(function () {
	/*
		This file shows how client-side javascript can be included via a plugin.
		If you check `plugin.json`, you'll see that this file is listed under "scripts".
		That array tells NodeBB which files to bundle into the minified javascript
		that is served to the end user.

		Some events you can elect to listen for:

		$(document).ready();			Fired when the DOM is ready
		$(window).on('action:ajaxify.end', function(data) { ... });			"data" contains "url"
	*/

	$(window).on('action:ajaxify.end', function (evt, data) {
		if (data.url === 'after-logout') {
			if (window.fetch) {
				NProgress.set(0.7);
				const urls = config.omnikomLoginManager.logoutRequests.split('\n').map(url => url.trim());
				Promise.all(urls.map((url) => {
					let method = 'GET';
					if (url.includes('members/api/session')) {
						method = 'DELETE';
					}
					return fetch(url, {
						method: method,
						credentials: 'include',
						redirect: 'manual',
					}).catch(console.error);
				})).then(() => {
					NProgress.done();
					$('#after-logout-wrapper .alert').fadeIn();
					$('#after-logout-wrapper a').removeClass('disabled');
				}).catch((err) => {
					console.error(err);
					NProgress.done();
					const $alert = $('#after-logout-wrapper .alert');
					$alert.removeClass('alert-success').addClass('alert-danger').fadeIn();
					$alert.find('strong').text('Wystąpił błąd podczas wylogowywania');
					$alert.find('p').text('Nie udało się pomyślnie wylogować ze wszystkich serwisów (Blog, Sklep)');
					$('#after-logout-wrapper a').removeClass('disabled');
				});
			}
		}
	});
	$(window).on('action:app.loggedOut', function (evt, data) {
		if (config.omnikomLoginManager.logoutRequests) {
			data.next = '/after-logout';
		}
	});
});
